import {Box, Typography} from '@mui/material';
import React from 'react';
import {ReactComponent as FolderIcon} from '../../../assets/images/no-data-found.svg';
import {t} from 'i18next';

const NoReport = () => {
  return (
    <Box className="no-report-container">
      <FolderIcon />
      <Typography
        className="typo-text headline3_size text-inverse-heading"
        data-testid={`no-report-no-report`}>
        {t('reports.communicationExplorer.NoReport')}
      </Typography>
    </Box>
  );
};

export default NoReport;
